import { render, staticRenderFns } from "./Formwork.vue?vue&type=template&id=df1d8bfa&scoped=true"
import script from "./Formwork.vue?vue&type=script&lang=js"
export * from "./Formwork.vue?vue&type=script&lang=js"
import style0 from "./Formwork.vue?vue&type=style&index=0&id=df1d8bfa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1d8bfa",
  null
  
)

export default component.exports